import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { OverviewView } from './components/OverviewView';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ClubDetailView } from './pages/club/ClubDetailView';
import { TGDetailView } from './pages/training-group/TGDetailView';

export const renderClubSearch = (backendUrl: string, id: string) => {
  const contentDiv = document.getElementById(id);
  contentDiv?.classList.add("aneta-clubsearch-root");
  const root = createRoot(contentDiv!);
  root.render(
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route path="/training-group/:id" element={<TGDetailView backendUrl={backendUrl} />} />
          <Route path="/club/:id" element={<ClubDetailView backendUrl={backendUrl} />} />
          <Route path="/" element={<OverviewView type="Club" backendUrl={backendUrl} />} />
        </Routes>
      </HashRouter>
    </React.StrictMode>
  )
}

export const renderTGSearch = (backendUrl: string, id: string) => {
  const contentDiv = document.getElementById(id);
  contentDiv?.classList.add("aneta-clubsearch-root");
  const root = createRoot(contentDiv!);
  root.render(
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route path="/:id" element={<TGDetailView backendUrl={backendUrl} />} />
          <Route path="/" element={<OverviewView type="TrainingGroup" backendUrl={backendUrl} />} />
        </Routes>
      </HashRouter>
    </React.StrictMode>
  )
}

//renderTGSearch("http://localhost:8080/api", "root");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
